import { AoInstance } from "./ao"
import { PoolOverview } from "./router"
import { getDataSource } from "../services/data-source"

/**
 * Fetch all pools
 */

export async function getPoolsOverview(ao: AoInstance): Promise<PoolOverview[]> {
  const dataSource = getDataSource(ao)
  return await dataSource.getPoolsOverview()
}
